var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_1990)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85768 3.38965H2.72827L10.1106 13.921H13.24L5.85768 3.38965ZM5.42715 4.05742H3.96694L10.5769 13.2531H12.001L5.42715 4.05742Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_936_1990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 12,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.24 3.38965H2.71997V13.9096H13.24V3.38965ZM5.42708 4.05742H3.96687L10.5769 13.2531H12.001L5.42708 4.05742Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_936_1990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9171 3.39648H11.9483L2.71997 13.9283H3.68872L12.9171 3.39648Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_1990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.0900879 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSmall);
export default __webpack_public_path__ + "static/media/X-small.17fcc2caa9cbd77e9fe8702c1bce542f.svg";
export { ForwardRef as ReactComponent };